import { z } from 'zod'

import { DateZod } from '../common'

import { ChannelMessageZod } from './channel-message-zod'
import { ChannelIdZod } from './channel-zod'

export const CHANNEL_MESSAGE_PAYLOAD_KEYS = ['text', 'firebaseStoragePath', 'imageProperties'] as const

export const ChannelMessageDeletionZod = ChannelMessageZod.pick({
  sender: true,
  senderId: true,
  senderName: true,
  senderSysAdmin: true,
  teamNumber: true,
  text: true,
  firebaseStoragePath: true,
  imageProperties: true,
  createdAt: true,
}).extend({
  regionId: z.string(),
  channelId: ChannelIdZod,
  eveningId: z.number(),
  messageId: z.string(),
  deletedAt: DateZod,
  deletedBy: z.string(),
  deletedByName: z.string(),
  // The label is stored rather than rebuilt at display: the consultation view takes its region name
  // from the link's query string, so a hand-edited link would otherwise reattribute the deletion.
  deletedByRegionName: z.string().nullish().default(''),
  deletedByRegionId: z.string().nullish().default(''),
  deletedBySysAdmin: z.boolean().nullish().default(false),
})

export type ChannelMessageDeletion = z.infer<typeof ChannelMessageDeletionZod>
